import React, { useState, useRef } from 'react';

export default function UploadFile({
  onUpload,
  accept = ['.pdf', '.txt', '.csv', '.json'],
  multiple = false,
  title = '請上傳檔案',
  subtitle = '支援格式：pdf / json / txt / csv',
  style={},
  directory = false
}) {
  const [files, setFiles] = useState([]);
  const inputRef = useRef(null);

  const handleFiles = (fileList) => {
    const accepted = Array.from(fileList).filter((file) => {
      const ext = '.' + file.name.split('.').pop().toLowerCase();
      return accept.includes(ext);
    });

    const finalFiles = multiple ? accepted : accepted.slice(0, 1);

    setFiles(finalFiles);
    if (onUpload) onUpload(finalFiles);
  };

  const handleChange = (e) => {
    handleFiles(e.target.files);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    handleFiles(e.dataTransfer.files);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  return (
    <div
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onClick={() => inputRef.current.click()}
      style={{
        ...{
        borderRadius: '32px',
        padding: '25px',
        width: '100%',
        maxWidth: '350px',
        cursor: 'pointer',
        textAlign: 'left',
        boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        fontFamily: 'Noto Sans TC, sans-serif',
        },
        ...style
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'scale(1.02)';
        e.currentTarget.style.boxShadow = '0 6px 18px rgba(0,0,0,0.4)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'scale(1.0)';
        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.3)';
      }}
    >
      <h2 style={{ fontSize: '1.5rem', fontWeight: '700', marginBottom: '12px' }}>{title}</h2>
      <p style={{ fontSize: '1.2rem', marginBottom: '12px' }}>{subtitle}</p>

      {/* 隱藏 input，點整個區塊會觸發 */}
      <input
        ref={inputRef}
        type="file"
        onChange={handleChange}
        multiple={multiple}
        accept={accept.join(',')}
        style={{ display: 'none' }}
        {...(directory ? { webkitdirectory: "true" } : {})}
      />

      {/* 顯示檔名 */}
      {files.length > 0 && (
        <ul style={{ marginTop: '10px', fontSize: '0.9rem' }}>
          {files.slice(0, 10).map((f, i) => (
            <li key={i}>
              {f.name} ({(f.size / 1024).toFixed(1)} KB)
            </li>
          ))}
          {files.length > 10 && (
            <li>...and {files.length - 10} more files</li>
          )}
        </ul>
      )}
    </div>
  );
}